export const filtersCustomScheme = [
  {
    id: 0,
    title: 'New Construction',
    imgSrc: require('@/assets/img/src/custom-filters/new-construction-min.jpg'),
    type: 'new_construction',
  },
  {
    id: 1,
    title: 'Foreclosures',
    imgSrc: require('@/assets/img/src/custom-filters/foreclosures-min.jpg'),
    type: 'foreclosures'
  },
  {
    id: 2,
    title: 'Pending Sales',
    imgSrc: require('@/assets/img/src/custom-filters/pending-sales-min.jpg'),
    type: 'pending_sales'
  },
  {
    id: 3,
    title: 'Condos',
    imgSrc: require('@/assets/img/src/custom-filters/condos-min.jpg'),
    type: 'condos'
  },
  {
    id: 4,
    title: 'Open Houses',
    imgSrc: require('@/assets/img/src/custom-filters/open-house-min.jpg'),
    type: 'open_houses'
  },
  {
    id: 5,
    title: 'Virtual Tours',
    imgSrc: require('@/assets/img/src/custom-filters/virtual-tours-min.jpg'),
    type: 'virtual_tours'
  }
];

export const propertyTypes = {
  'Commercial': {
    icon: 'app-icon-pt__other-type'
  },
  'Lots And Land': {
    icon: 'app-icon-pt__land'
  },
  'MultiFamily': {
    icon: 'app-icon-pt__multi-family'
  },
  'Rental': {
    icon: 'app-icon-pt__townhouse'
  },
  'Residential': {
    icon: 'app-icon-pt__house'
  },
  'Other': {
    icon: 'app-icon-pt__other-type'
  },
};



export const counties = ['Cook', 'Lake', 'DuPage', 'Kane', 'Will', 'McHenry', 'Kendall', 'Kankakee'];

export const getFiltersParams = (filters) => {
  let params = {};

  filters.forEach( filter => {
    if (filter.type === 'value' || filter.type === 'select') {
      if (filter.values[0] !== null && filter.values[0] !== '') {
        params[filter.name] = filter.values[0]
      }
    } else if (filter.type === 'range') {
      if (filter.values[0] !== null  && filter.values[0] !== '') {
        params[(filter.name + '_min')] = filter.values[0]
      }
      if (filter.values[1] !== null  && filter.values[1] !== '') {
        params[(filter.name + '_max')] = filter.values[1]
      }
    } else if (filter.type === 'multiselect') {
      if (filter.values.length > 0) {
        params[filter.name] = filter.values.join();
      }
    }
  });

  return params
}

export const setFiltersFromParams = (filters, query) => {
  let queryKeys = Object.keys(query);

  filters.forEach(filter => {
    queryKeys.forEach(key => {
      if (key.indexOf(filter.name) > -1) {
        if (filter.type === 'value' || filter.type === 'select') {
          filter.values[0] = query[key];
        } else if (filter.type === 'range') {
          let keyParts = key.split('_')
          if (keyParts[keyParts.length - 1] === 'min') {
            filter.values[0] = query[key];
          } else if (keyParts[keyParts.length - 1] === 'max') {
            filter.values[1] = query[key];
          }
        } else if (filter.type === 'multiselect') {
          filter.values = query[key].split(',');
        }
      }
    });
  })

  return filters
}
